import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import classNames from 'classnames'
import style from './ProgressBar.module.scss'

const ProgressBar = ({ className, stepNumber, step, type }) => {
  const { color } = useContext(ClientContext)
  const progressSteps = [...Array(stepNumber).keys()]

  return (
    <div className={classNames(style.progress, style[type], className)}>
      {progressSteps.map(item => {
        return (
          <div
            className={classNames(style.step, item === step && style.current, item <= Math.floor(step) && style.done)}
            key={`progress-step-${item}`}
            style={{
              width: `${100 / stepNumber}%`,
              backgroundColor: item <= Math.floor(step) && color
            }}
          ></div>
        )
      })}
    </div>
  )
}

export default ProgressBar
